<template>
  <section class="group">
    <b-collapse :open="true" class="card" style="box-shadow: none">
      <div
        :class="{ 'card-header__border': props.open }"
        slot="trigger"
        slot-scope="props"
        class="card-header"
      >
        <p class="card-header-title">
          <span class="group_name is-medium-16-500-19">{{localization('app-properties','Properties')}}</span>
        </p>
        <a class="card-header-icon">
          <svg viewBox="0 0 100 100" class="image is-24x24">
            <use
              v-if="!props.open"
              xlink:href="@/assets/icons/sprite.svg#collapse"
            />
            <use
              v-else
              xlink:href="@/assets/icons/sprite.svg#expand-feature-types"
            />
          </svg>
        </a>
      </div>
      <div class="card-content">
        <table class="table">
          <tbody>
            <tr v-for="(val, key) in props_count" :key="key">
              <td class="is-capitalized">
                {{ (key.split("__terra")[1]).split("_").join(" ") }}
              </td>
              <td>
                {{ val }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-collapse>
  </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["active_projects"]),
    props_count() {
      let obj = {};
      Object.values(this.active_projects || []).forEach((project) => {
        if (project.is_feature_active && project.info.properties) {
          Object.keys(project.info.properties).forEach((key) => {
            if (key.includes("__terra")) {
              obj[key] =
                (obj[key] || 0) + parseInt(project.info.properties[key]);
            }
          });
        }
      });
      return obj;
    },
  },
};
</script>

<style>
</style>